var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.categoryList, function(category, index) {
      return _c("div", { key: "cate_" + index }, [
        _c(
          "div",
          {
            class: {
              cetegory_item: true,
              active: category.id === _vm.selCategoryNo
            },
            on: {
              click: function($event) {
                _vm.selectCategory(category)
              }
            }
          },
          [
            _c("div", [
              category.id !== _vm.selCategoryNo
                ? _c("img", {
                    attrs: { src: _vm.categoryImgBlack(category.img) }
                  })
                : _c("img", {
                    attrs: { src: _vm.categoryImgWhite(category.img) }
                  })
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(category.name))])
          ]
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-403ccfe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403ccfe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/top/DcCategoryList.vue
// module id = null
// module chunks = 